import { render } from "./WalletConnectModal.vue?vue&type=template&id=2d0638d8"
import script from "./WalletConnectModal.vue?vue&type=script&lang=js"
export * from "./WalletConnectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__